import { render } from "./PomeloConfirm.vue?vue&type=template&id=2a76f644"
import script from "./PomeloConfirm.vue?vue&type=script&lang=js"
export * from "./PomeloConfirm.vue?vue&type=script&lang=js"

import "./PomeloConfirm.vue?vue&type=style&index=0&id=2a76f644&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__